export default () => ({
    root: {
        display: "flex",
        justifyContent: "space-around",
        flexWrap: "wrap",
    }
});